// JsFromRoutes CacheKey ee2cc6b48e5cf729cf2de4689d591c95
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client";

export default {
  purchaseProofEligibleProducts: /* #__PURE__ */ definePathHelper(
    "get",
    "/admin/v2/programs/:program_id/challenges/purchase_proof_eligible_products",
  ),
  toggleApproval: /* #__PURE__ */ definePathHelper(
    "post",
    "/admin/v2/challenges/:id/toggle_approval",
  ),
  duplicate: /* #__PURE__ */ definePathHelper(
    "post",
    "/admin/v2/challenges/:id/duplicate",
  ),
  toggleTag: /* #__PURE__ */ definePathHelper(
    "post",
    "/admin/v2/challenges/:id/toggle_tag",
  ),
  index: /* #__PURE__ */ definePathHelper(
    "get",
    "/admin/v2/programs/:program_id/challenges",
  ),
  adminV2ParticipantChallenges: /* #__PURE__ */ definePathHelper(
    "get",
    "/admin/v2/participants/:participant_id/challenges",
  ),
  create: /* #__PURE__ */ definePathHelper(
    "post",
    "/admin/v2/programs/:program_id/challenges",
  ),
  new: /* #__PURE__ */ definePathHelper(
    "get",
    "/admin/v2/programs/:program_id/challenges/new",
  ),
  edit: /* #__PURE__ */ definePathHelper(
    "get",
    "/admin/v2/challenges/:id/edit",
  ),
  show: /* #__PURE__ */ definePathHelper("get", "/admin/v2/challenges/:id"),
  update: /* #__PURE__ */ definePathHelper("patch", "/admin/v2/challenges/:id"),
  destroy: /* #__PURE__ */ definePathHelper(
    "delete",
    "/admin/v2/challenges/:id",
  ),
};
